import { initializeForms } from "./form.js";
const $ = jQuery;

window.oooGetElementSettings = ($scope) => {
	return JSON.parse(atob($scope[0].dataset.frontendAvailableSettings));
};
window.oooRegisterBlueprintHandler = (
	handler,
	{ bricks: { selector, builderFunctionName = false } },
) => {
	const bf = new BricksFunction({
		selector: selector,
		eachElement: (el) => handler($(el), "bricks"),
	});
	if (builderFunctionName) {
		window[builderFunctionName] = () => bf.run();
	}
	document.addEventListener("DOMContentLoaded", function (event) {
		if (bricksIsFrontend) {
			bf.run();
		}
	});
};

window.initMap = () => {
	const event = new Event("ooo-google-maps-api-loaded");
	window.dispatchEvent(event);
};
/**
 * Parses a setting value (slider/number) and returns a standardized object.
 * @param {*} settingValue The raw setting value.
 * @param {string} [defaultUnit=''] The default unit to assume if not found.
 * @returns {{size: number, unit: string}}
 */
window.oooParseSliderSetting = (settingValue, defaultUnit = "") => {
	let size = 0;
	let unit = defaultUnit;

	if (
		typeof settingValue === "object" &&
		settingValue !== null &&
		typeof settingValue.size !== "undefined"
	) {
		// Elementor slider format {size: ..., unit: ...}
		size = parseFloat(settingValue.size) || 0;
		unit =
			typeof settingValue.unit === "string" && settingValue.unit
				? settingValue.unit
				: defaultUnit;
	} else if (typeof settingValue === "string") {
		// Bricks string format (e.g., '25px', '50%', '10em', or just '25')
		const match = settingValue.match(/^([+-]?\d*\.?\d+)\s*([a-zA-Z%]+)?$/);
		if (match) {
			size = parseFloat(match[1]) || 0;
			if (match[2]) {
				// Unit captured
				unit = match[2];
			}
		} else {
			size = parseFloat(settingValue) || 0;
		}
	} else if (typeof settingValue === "number") {
		// Bricks number format (just the number)
		size = settingValue;
	}

	return { size: size, unit: unit };
};

/**
 * Gets only the numeric size from an Elementor SLIDER control's value.
 * @param {*} sliderValue The raw setting value.
 * @param {string} [defaultUnit=''] The default unit (passed to parser).
 * @returns {number}
 */
window.oooGetSliderSize = (sliderValue, defaultUnit = "") => {
	const parsed = oooParseSliderSetting(sliderValue, defaultUnit);
	return parsed.size;
};

/**
 * Gets only the unit from an Elementor SLIDER control's value.
 * @param {*} sliderValue The raw setting value.
 * @param {string} [defaultUnit=''] The default unit.
 * @returns {string}
 */
window.oooGetSliderUnit = (sliderValue, defaultUnit = "") => {
	const parsed = oooParseSliderSetting(sliderValue, defaultUnit);
	return parsed.unit;
};

/**
 * Gets the combined 'size + unit' string from an Elementor SLIDER control's value.
 * Handles cases where the unit might be empty.
 * @param {*} sliderValue The raw setting value.
 * @param {string} [defaultUnit=''] The default unit.
 * @returns {string}
 */
window.oooGetSliderString = (sliderValue, defaultUnit = "") => {
	const parsed = oooParseSliderSetting(sliderValue, defaultUnit);
	return parsed.unit ? parsed.size + parsed.unit : String(parsed.size);
};

document.addEventListener("DOMContentLoaded", initializeForms);
